(function (angular) {
  "use strict";

  angular.module("app").controller("gdprModal", signupGdprModal);

  signupGdprModal.$inject = [
    "alerts",
    "$scope",
    "$rootScope",
    "$uibModalInstance",
    "SettingsApi",
    "UsersApi",
    "confirmDialog",
    "shouldDeleteUserIfRejected",
  ];

  function signupGdprModal(
    alerts,
    $scope,
    $rootScope,
    $uibModalInstance,
    SettingsApi,
    UsersApi,
    confirmDialog,
    shouldDeleteUserIfRejected,
  ) {
    var vm = this;

    // properties
    vm.isLoading = true;
    vm.isLoadingMessage = "Loading...";
    vm.canClose = false;

    // methods
    vm.submit = submit;
    vm.cancel = cancel;

    /**
     * Shows confirm modal to delete this account - if GDPR terms are not accepted
     * @return {void}
     */
    function deleteAccount() {
      confirmDialog(
        "Are you sure you want to delete your account?",
      ).result.then(function (confirm) {
        if (confirm) {
          vm.isLoadingMessage = "Deleting your account...";
          vm.isLoading = true;

          UsersApi.delete(
            {
              id: $rootScope.thisUser.id,
            },
            function handleDeleteUserResponse() {
              vm.canClose = true;
              $uibModalInstance.dismiss("deleted");

              // if (vm.thisUser.id === vm.user.id) {
              //     $window.location = '/signout';
              // }
            },
            function handleDeleteUserError() {
              vm.isLoading = false;
            },
          );
        }
      });
    }

    function submit() {
      vm.canClose = true;
      $uibModalInstance.close(vm.settings);
    }

    function cancel() {
      if (shouldDeleteUserIfRejected) {
        return deleteAccount();
      }

      vm.canClose = true;
      $uibModalInstance.dismiss("cancel");
    }

    // init
    SettingsApi.get(
      {},
      function (response) {
        vm.isLoading = false;
        vm.settings = response.data.gdpr_settings;
      },
      alerts.emit,
    );

    $scope.$on("modal.closing", function (event, reason, closed) {
      if (!vm.canClose) {
        return event.preventDefault();
      }
    });
  }
})(angular);
